import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class ColorTableVO extends VisualVO {
    public level: number = 0;
    public colorTable: number = 0;
    public color: string;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }
    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.color = (wodElement['color'] || '');
        this.colorTable = parseInt((wodElement['colorTable'] || ''));
        this.level = parseInt((wodElement['level'] || ''));
    }
}
classImplementsInterfaces(ColorTableVO, "IInventoryVO");
